<app-collapsible-container [id]="'addresses'"
                           [title]="'REPERTOIRE.FORMS.ADDRESS.TITLE'"
                           [icon]="'i-home'"
                           (elementSizeModification)="elementSizeModification.emit()"
>
    <div [ngClass]="{'closed__parent1': !addressParent1.value, 'closed__parent2': !addressParent2.value}">
        <app-generic-radio-checkbox
            [config]="{
                    formGroupName: 'radioAdress',
                    inputType: 'radio',
                    questionChoices: [
                        {
                            label: 'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.PARENT1',
                            value: 'parent1'
                        },
                        {
                            label: 'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.PARENT2',
                            value: 'parent2'
                        },
                        {
                            label: 'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.OTHER',
                            value: 'other'
                        }
                    ]
                }"
            [formControl]="radioAdress"
            class="horizontal"
        >
        </app-generic-radio-checkbox>
        <!-- <app-generic-button
            (buttonClick)="showAddress('parent1')"
            [classes]="'btn btn--light'"
            [inputText]="'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.PARENT1'"
            [ngClass]="{ selected: addressShown === 'parent1' }"
        >
        </app-generic-button>

        <app-generic-button
            (buttonClick)="showAddress('parent2')"
            [classes]="'btn btn--light'"
            [inputText]="'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.PARENT2'"
            [ngClass]="{ selected: addressShown === 'parent2' }"
        >
        </app-generic-button>

        <app-generic-button
            (buttonClick)="showAddress('other')"
            [classes]="'btn btn--light'"
            [inputText]="'REPERTOIRE.FORMS.ADDRESS.LABELS.STUDENT-LABELS.OTHER'"
            [ngClass]="{ selected: addressShown === 'other' }"
        >
        </app-generic-button> -->
    </div>
    <ng-container [ngSwitch]="radioAdress.value">
        <app-address
            *ngSwitchCase="'parent1'"
            [formControl]="addressParent1"
            [readOnly]="true"
            (elementSizeModification)="elementSizeModification.emit()"
        ></app-address>
        <app-address
            *ngSwitchCase="'parent2'"
            [formControl]="addressParent2"
            [readOnly]="true"
            (elementSizeModification)="elementSizeModification.emit()"
        ></app-address>
        <app-address
            *ngSwitchCase="'other'"
            [formControl]="addressOther"
            [entityType]="entityType"
            (elementSizeModification)="elementSizeModification.emit()"
        ></app-address>
    </ng-container>
</app-collapsible-container>

